module.exports = __webpack_public_path__ + "static/media/opt-to-notify2.41f116d8.jpg";